import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Route, Router } from '@angular/router';
import { PlatformType } from '@root/config';
import { TranslateService } from '@root/shared/service/translate.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';

@Component({
  selector: 'room-type-detail-channels-linked',
  templateUrl: './channels-linked.component.html',
  styleUrls: ['./channels-linked.component.scss'],
})
export class RTChannelsLinkedComponent implements OnInit {
  readonly LinkedListingsApi = '/api/house_type/platform_list';
  @Input() id;
  listOfLinkedListings;
  total;
  pageSize = 20;
  page = 1;
  constructor(
    private http: HttpClient,
    private modal: NzModalService,
    private msg: NzMessageService,
    private t: TranslateService,
    private router: Router
  ) {}

  ngOnInit() {
    this.initSourceData();
  }

  private initSourceData() {
    const params = { house_type_id: this.id };
    this.http.get(this.LinkedListingsApi, { params }).subscribe((rst: any) => {
      this.listOfLinkedListings = rst?.data?.list;
    });
  }

  private requestShelf(id, status) {
    const params = {
      house_type_price_id: id,
      status,
    };
    this.http.post('/api/house/shelf', params).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.msg.success(this.t.t(status === 1 ? 'success.put_on_shelves' : 'success.pull_off_shelves'));
        this.initSourceData();
      }
    });
  }

  private requestUnbind(house) {
    const params = {
      house_type_id: house.house_type_id,
      house_type_price_id: house.house_type_price_id,
    };

    this.http.post('/api/house_type/unbind_relation', params).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.initSourceData();
      }
    });
  }

  /** 下架 */
  onUnshelf(house) {
    const thirdpartyType = house.thirdparty_type;
    if (thirdpartyType === PlatformType.TuJia) {
      this.modal.warning({
        nzContent: '暂不支持下架来自途家线上的房源，请登录途家后台下架房源。',
        nzCancelText: null,
      });
    } else if (
      thirdpartyType === PlatformType.MeiTuanMinSu &&
      house.oauth_status !== 1 // 未授权
    ) {
      this.modal.warning({
        // 当前房源所属账号未直连，无法在百居易操作下架，是否现在直连？
        nzContent: this.t.t('warning.house.pull_unauthorized_channel_house_off_shelves'),
        nzCancelText: this.t.t('house.not_direct_connect_immediately'),
        nzOkText: this.t.t('house.direct_connect_immediately'),
        nzOnOk: () => this.router.navigate(['/app/connected-accounts/list']),
      });
    } else {
      this.modal.warning({
        // 下架后房源将无法被预订，已有订单不受影响，确定下架吗？
        nzContent: this.t.t('warning.house.pull_channel_house_off_shelves'),
        nzCancelText: this.t.t('word.cancel'),
        nzOkText: this.t.t('word.confirm'),
        nzOnOk: () => this.requestShelf(house.house_type_price_id, 0),
      });
    }
  }

  onShelf(house) {
    this.requestShelf(house.house_type_price_id, 1);
  }

  onUnbind(house) {
    this.modal.warning({
      nzTitle: this.t.t('warning.house.confirm_remove_channel_house'),
      nzContent: this.t.t('warning.house.remove_channel_house_info'),
      nzCancelText: this.t.t('word.cancel'),
      nzOnOk: () => this.requestUnbind(house),
    });
  }
}
